import { useQuery, UseQueryResult } from 'react-query';

import { useAuth } from 'src/hooks';
import { getPersonAlertsPreview } from 'src/utils/urls';

import { PersonAlertsAccountsDetails } from 'src/features/AddEditPersonAlert/types/personAlertsAccounts';

async function fetchPersonAlertPreview({
  token,
  tokenType,
  accountId,
  alertId,
  type,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    getPersonAlertsPreview(accountId, alertId, type),
    {
      method: 'GET',
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    },
  );
  return response.json();
}

export type TResult = PersonAlertsAccountsDetails;

export type TVariables = {
  token: string;
  tokenType: string;
  accountId: number;
  alertId: number;
  type?: string;
};

export type TError = { message: string };

function useGetPersonAlertPreview(
  accountId: number | undefined,
  alertId: number | undefined,
  isEnable: boolean,
  type?: string,
): UseQueryResult<TResult, TError> {
  const { token, tokenType } = useAuth();

  return useQuery(
    ['get_person_alert_preview', accountId, alertId, type],
    async () => {
      if (accountId && alertId) {
        const result = await fetchPersonAlertPreview({
          token,
          tokenType,
          accountId,
          alertId,
          type,
        });
        return result;
      }
    },
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: isEnable,
    },
  );
}

export { useGetPersonAlertPreview };
